import { render, staticRenderFns } from "./TeachersAll.vue?vue&type=template&id=0e25d47c&scoped=true"
import script from "./TeachersAll.vue?vue&type=script&lang=js"
export * from "./TeachersAll.vue?vue&type=script&lang=js"
import style0 from "./TeachersAll.vue?vue&type=style&index=0&id=0e25d47c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e25d47c",
  null
  
)

export default component.exports